<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emDictTypeResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      withCustomRowActions
                                      customRowActionsText="修改配置"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="edit"  custom-icon="fa fa-fw fa-lg fa-question"
                                                   custom-label="查看配置"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'" @click="showEdit(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <re-b-modal ref="emDictData" header= '配置'
                    no-close-on-backdrop
                    fit-content
                    large
                    @hide="triggerHide">
            <div class="d-flex flex-column h-100 position-relative">
                <mini-table ref="emDictDataTable"
                            class="flex-grow-1 overflow-auto"
                            entity-name="emDictData"
                            :items="emDictDataRecord"
                            :fields="editTableFields"
                            :total-count="totalCount"
                            read-only sortable
                            enable-pagination
                            addition-columns="isDefault"
                            disable-first-index-column
                            need-model-fields
                            @pageChange="whenPageChange">
                    <template #rightHeader>
                        <b-button class="ml-1" variant="success"
                                  :disabled="saving"
                                  v-show="editAble"
                                  @click="addDictData()">
                            新增
                        </b-button>
                        <b-button class="ml-1" variant="success"
                                  :disabled="saving"
                                  v-show="editAble"
                                  @click="saveEmDictData(row)">
                            保 存
                        </b-button>
                        <b-button class="ml-1 mr-1" :variant="editAble ? 'outline-warning' : 'outline-success'"
                                  @click="triggerTableEdit()">
                            {{ editAble ? '关闭编辑' : '开启编辑' }}
                        </b-button>
                    </template>
                    <template #addition(isDefault)="{row}">
                        <b-button variant="success" v-if="row.isDefault==='N' && !editAble"
                                  @click="setDefault(row)">
                            <i class="fa-solid fa-check"></i>
                        </b-button>
                    </template>>
                    <template #endOfRow="{row}">
                    </template>
                </mini-table>
            </div>
        </re-b-modal>
    </div>
</template>
<script>
    // Author lidongxu
    // Date 2023-08-17 14:04:13

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCustomVuexMixin from "@/mixin/em/customVuex";
    import MiniTable from "@/components/common/mini-table/MiniTable.vue";
    import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
    import emCommonApiMixin from "@/mixin/em/common/api";
    import commonViewsUtil from "@/utils/commonViewsUtil";
    import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

    export default {
        data() {
            return {
                // 正在保存
                saving: false,
                editAble: false,
                emDictDataRecord:[],
                showEditTable: false,
                row : [],
                totalCount: 100,
                page: {
                    pageNumber: 1,
                    pageSize: 10,
                },
                dataRow : [],
            }
        },
        name: "emDictTypeListView",
        components: {ReBModal, MiniTable},
        mixins: [emCommonListMixin, emCustomVuexMixin,emCommonApiMixin,emCommonUtilMixin],
        props: {
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            },
        },
        methods : {
            whenPageChange(page,row) {
                this.page = page;
                this.doQuery(row);
            },
            setDefault (row) {
                this.dataRow = row;
                let self = this
                let uri = `${this.$_emApiMixin_moduleBaseApi('emDictData')}/emDictData/modifyDictDataDefault?dictType=${this.dataRow.dictType}&id=${this.dataRow.id}`;
                this.$_emApiMixin_post(uri)
                    .then(response => {
                        if (response.status === 200) {
                            self.$message({
                                message: "更新成功",
                                type: "success",
                            });
                            self.doQuery(row);
                        } else {
                            self.$message({
                                message: "更新失败",
                                type: "error",
                            });
                        }
                    })
                    .finally(() => self.doQuery())
            },
            triggerHide() {
                this.emDictDataRecord = []
                this.editAble = false;
            },
            addDictData () {
                this.emDictDataRecord.push([]);
            },
            showEdit(row) {
                this.row = row;
                this.doQuery();
                this.$refs.emDictData.showModal();
            },
            doQuery() {
                let form = {
                    dictTypeFilter: this.row.dictType,

                    sortingBy : [{column: "isDefault", order: "desc"},{column: "dictValue", order: "asc"}]
                }
                let nPage = {
                    currentPage: this.page.pageNumber,
                    numRegPag: this.page.pageSize,
                }
                this.copyObj2Obj(nPage, form);
                let uri  = `${this.$_emApiMixin_entityBaseApi('emDictData')}/findByFilter`;
                this.$_emApiMixin_post(uri,form)
                    .then((response)=> {
                        this.emDictDataRecord = response.data.list
                        this.totalCount = response.data.pagination.totalReg
                    });
            },
            triggerTableEdit() {
                this.editAble = !this.editAble;
            },
            saveEmDictData(row) {
                let columnEditData = this.$refs.emDictDataTable.columnEditData();
                console.log("修改的数据为"+JSON.stringify(columnEditData))
                if (columnEditData && columnEditData.length > 0) {
                    this.saving = true;
                    let uri = `${this.$_emApiMixin_moduleBaseApi('emDictData')}/emDictData/saveAllSelective`;
                    this.$_emApiMixin_put(uri
                        , columnEditData)
                        .then(() => {
                            commonViewsUtil.showSuccess(this, "保存成功");
                            this.doQuery(row);
                            this.editAble = false;
                        }).finally(() => this.saving = false);
                }
            },
        },
        computed: {
            editTableFields() {
                if (!this.editAble) {
                    return [];
                }
                return [
                    {
                        key: 'dictType',
                        isInput: false,
                        form: {
                            type: 'input',
                            modalMultiSelectedType: 'string'
                        },
                        defaultValue: this.row.dictType,
                        isEditInvisible: true
                    },
                    {
                        key: 'dictValue',
                        isInput: true,
                        form: {
                            type: 'input',
                            modalMultiSelectedType: 'string'
                        },
                        isEditInvisible: true
                    },
                    {
                        key: 'dictLabel',
                        isInput: true,
                        form: {
                            type: 'input',
                            modalMultiSelectedType: 'string'
                        },
                        isEditInvisible: true
                    },
                    {
                        key: 'status',
                        isInput: true,
                        form: {
                            type: 'select',
                            modalMultiSelectedType: 'string'
                            ,options: [
                                { value: '0', text: '启用' },
                                { value: '1', text: '停用' }
                            ]
                        },
                        defaultValue: '0',
                        isEditInvisible: true
                    },
                    {
                        key: 'isDefault',
                        isInput: false,
                        form: {
                            type: 'select',
                            modalMultiSelectedType: 'string'
                            ,options: [
                                { value: 'Y', text: '是' },
                                { value: 'N', text: '否' }
                            ]
                        },
                        defaultValue: 'N',
                        isEditInvisible: true
                    },
                    {
                        key: 'remark',
                        isInput: true,
                        form: {
                            type: 'input',
                            modalMultiSelectedType: 'string'
                        },
                        isEditInvisible: true
                    }
                ];
            },
            modelName() {
                return this.$_emRouterHelperMixin_entityName
            }
        }
    };
</script>
